import { ComponentProps } from 'react'
import { stencil } from 'react-common'
import { useAuth } from '@/features/auth/useAuth'
import { useAuthThunks } from '@/hooks/useAuthThunks'

const { ImpersonationPlugin } = stencil

export const ImpersonationContainer = () => {
  const { handleLogout } = useAuthThunks()
  const { user } = useAuth()

  return (
    <ImpersonationPlugin
      onSignOut={handleLogout}
      user={user as unknown as ComponentProps<typeof ImpersonationPlugin>['user']}
    />
  )
}
